// The API stores times as ISO UTC; employees work in the Philippines (UTC+8).
// Everything shown to the user, and every time sent back, uses Manila time.

const TIME_ZONE = "Asia/Manila";
const MANILA_OFFSET = "+08:00";

const partsFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

// ISO -> { dateKey: "YYYY-MM-DD", time: "HH:mm" } in Manila time.
export const toManilaParts = (iso) => {
  if (!iso) return null;
  const parts = Object.fromEntries(
    partsFormatter.formatToParts(new Date(iso)).map((p) => [p.type, p.value]),
  );
  return {
    dateKey: `${parts.year}-${parts.month}-${parts.day}`,
    time: `${parts.hour}:${parts.minute}`,
  };
};

export const todayManilaKey = () =>
  toManilaParts(new Date().toISOString()).dateKey;

export const currentManilaPeriod = () => {
  const [year, month] = todayManilaKey().split("-").map(Number);
  return { year, month };
};

// "YYYY-MM-DD" + n days, without going through local time.
export const addDaysToKey = (dateKey, days) => {
  const [y, m, d] = dateKey.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
};

// ("2026-09-02", "18:05") -> "2026-09-02T18:05:00+08:00"
export const buildManilaIso = (dateKey, time, nextDay = false) =>
  `${nextDay ? addDaysToKey(dateKey, 1) : dateKey}T${time}:00${MANILA_OFFSET}`;

export const formatManilaTime = (iso) =>
  iso
    ? new Date(iso).toLocaleTimeString("en-PH", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: TIME_ZONE,
      })
    : "—";

export const formatManilaDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-PH", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZone: TIME_ZONE,
      })
    : "—";

export const formatManilaDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-PH", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: TIME_ZONE,
      })
    : "—";

export const hoursBetween = (startIso, endIso) =>
  startIso && endIso
    ? (new Date(endIso) - new Date(startIso)) / 3_600_000
    : null;
